import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "footer-links" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { "data-e2e": "footer-logged-in" }
const _hoisted_5 = { class: "disclaimer" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "disclaimer" }, [
  /*#__PURE__*/_createTextVNode(" This site is protected by reCAPTCHA and the Google "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://policies.google.com/privacy",
    target: "_blank"
  }, "Privacy Policy"),
  /*#__PURE__*/_createTextVNode(" and "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://policies.google.com/terms",
    target: "_blank"
  }, "Terms of Service"),
  /*#__PURE__*/_createTextVNode(" apply. ")
], -1)
const _hoisted_7 = {
  key: 0,
  class: "artificial-tests"
}
const _hoisted_8 = ["textContent"]
const _hoisted_9 = ["src"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _directive_t = _resolveDirective("t")

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createElementVNode("button", {
            class: "link",
            onClick: _cache[0] || (_cache[0] = $event => ($options.openPrizes()))
          }, _toDisplayString(_ctx.$t('prizes_copy')), 1)
        ]),
        _withDirectives(_createElementVNode("li", null, null, 512), [
          [_directive_t, { key: 'rules_rs', tb2URL: _ctx.app.tb2URL }]
        ]),
        _withDirectives(_createElementVNode("li", null, null, 512), [
          [_directive_t, 'privacy']
        ]),
        _withDirectives(_createElementVNode("li", null, null, 512), [
          [_directive_t, 'donotsell']
        ]),
        _withDirectives(_createElementVNode("li", null, null, 512), [
          [_directive_t, 'cookies']
        ]),
        _withDirectives(_createElementVNode("li", null, null, 512), [
          [_directive_t, 'terms']
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("a", {
            href: "/faq",
            onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => ($options.openPopup && $options.openPopup(...args)), ["prevent"]))
          }, _toDisplayString(_ctx.$t('faq_copy')), 1)
        ]),
        _withDirectives(_createElementVNode("li", null, null, 512), [
          [_directive_t, 'snackworks']
        ]),
        (_ctx.loggedIn)
          ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, [
                _createElementVNode("a", {
                  href: "/",
                  class: "btn_logout",
                  "data-e2e": "footer-logout",
                  onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.logOut && _ctx.logOut(...args)))
                }, " Log Out ")
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_5, null, 512), [
      [_directive_t, { key: 'disclaimer', tb2URL: _ctx.app.tb2URL }]
    ]),
    _hoisted_6,
    (!_ctx.$store.state.ui.rapidTemplate)
      ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
          _createElementVNode("span", {
            class: "test-copy",
            textContent: _toDisplayString(_ctx.$t('testNamespace:testKey'))
          }, null, 8, _hoisted_8),
          _createElementVNode("img", {
            class: "language-flag",
            alt: "Language flag",
            src: _ctx.$i18nAsset('img/flag.svg'),
            style: {"display":"inline","width":"2em","padding":"0 0.5em","vertical-align":"middle"}
          }, null, 8, _hoisted_9)
        ]))
      : _createCommentVNode("", true)
  ]))
}